import { CircularProgress, Grid } from '@material-ui/core';
import React from 'react';
import CustomAppBar from '../../commons/AppBar';
import AlertNew from '../../commons/dialogs/AlertNew';
import ProgramLucru from '../../commons/dialogs/ProgramLucru';
import SpecificComponent from '../../commons/SpecificComponent';
import LocalStorage from '../../providers/LocalStorage';
import Utils from '../../providers/Utils';
import Ws from '../../providers/Ws';
import WsC from '../chestionare/providers/WsC';
import FisaPersonalaAngajare from './FisaPersonalaAngajare';
import FisaPersonalaCandidat from './FisaPersonalaCandidat';
import FisaPersonalaReadOnly from './FisaPersonalaReadOnly';
import RaportPersonalSubItem from './RaportPersonalSubItem';


export default class RaportPersonal extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {
            angajat: null,
            departamente: [],
            evaluari: {},
            readOnly: true,
            loading: true,
            programSelectat: -1,
            programLucru: [],
            isOpenProgram: false,
            programCompanie: [],
            programSelectat: -1,
            alertView: false
        }
    }

    componentDidMount() {

        this.access()
        this.getData()
        this.getProgramCompanie()
    }

    ws = new Ws()
    u = new Utils()
    ls = new LocalStorage().GetUserData()
    wsC = new WsC()



    access = async () => {



        console.log('this.ls.InfoUser.IsAdmin :>> ', this.ls.InfoUser.IsAdmin);

        if (this.ls.InfoUser.IsAdmin !== 1) {


            this.setState({ alertView: this.ls.InfoUser.EsteSef === 1 ? false : true })
        }


    }


    numeAvatar = (nume) => {

        if (nume) {
            let n = nume.split(' ')

            // console.log('n :>> ', n);

            let firstLetters = ''

            if (n[0]) {

                firstLetters += n[0].substring(0, 1)

            }
            if (n[1]) {
                firstLetters += n[1].substring(0, 1)
            }

            firstLetters = firstLetters.toUpperCase()

            return firstLetters
        } else {
            return 'NA'
        }


    }

    getData = async () => {





        let _angajati = this.ws.customSelect(`select a.*, ad.id_departament, u.is_admin from angajati a left join angajati_departamente ad
        on a.id = ad.id_angajat left join useri u  
        on u.id = a.id_user where a.id = @p1`, {
            p1: this.props.match.params.idAngajat
        })

        let _departamente = this.ws.customSelect(`select * from departamente where isnull(inactiv,0) != 1`, {
            p1: 1
        })

        let _evaluari = this.wsC.customSelect(`select e.*, a.poza, a.functie, a.nume as nume_user, (select count(*) from raspunsuri_head where id_evaluare = e.id and statusul = @p1) as completari_finalizate, 
        (select count(*) from raspunsuri_head where id_evaluare = e.id ) as completari_toate, s.nume
from evaluari e left join [${this.ls.InfoUser.Database}].[dbo].[angajati] a on a.id_user = e.id_user_aprobare
left join sesiuni s on s.id = e.id_sesiune
where a.id = @p2  and s.baza_date = @p3 and isnull(e.inactiv,0) != 1 ` , {
            p1: 'Finalizat',
            p2: this.props.match.params.idAngajat,
            p3: this.ls.InfoUser.Database
        })


        let _raspunsuri = this.wsC.customSelect(`select r.*, h.id_evaluare from raspunsuri_intrebari r left join raspunsuri_head h on r.id_head = h.id
 order by isnull(ordinea,0) asc, id`, {
            p1: this.props.match.params.idsesiune
        })

        let _optiuniRaspuns = this.wsC.customSelect(`select r.*, h.id_evaluare, h.statusul from raspunsuri_intrebari_raspunsuri r left join raspunsuri_head h on r.id_head = h.id 
    order by r.id_optiune_raspuns asc`, {
            p1: this.props.match.params.idsesiune,

        })

        let _programLucru = this.ws.customSelect('select * from program_lucru where id_angajat = @p1 ', {
            p1: this.props.match.params.idAngajat
        })



        let [angajati, departamente, evaluations, raspunsuri, optiuniRaspuns, programLucru] = await Promise.all([_angajati, _departamente, _evaluari, _raspunsuri, _optiuniRaspuns, _programLucru])
        console.log('angajati :>> ', angajati);
        console.log('departamente :>> ', departamente);

        if (angajati.Succes && departamente.Succes && evaluations.Succes && raspunsuri.Succes && optiuniRaspuns.Succes && programLucru.Succes) {

            let ang = { ...angajati.Content[0] }
            let dep = [...departamente.Content]
            let evaluari = [...evaluations.Content]
            let optiuniR = [...optiuniRaspuns.Content]
            let intrebari = [...raspunsuri.Content]

            let program = programLucru.Content.length > 0 ? { ...programLucru.Content[0] } : null

            ang.lu_start = program ? this.u.transformTimeFromSql(program.lu_start) : '00:00'
            ang.lu_end = program ? this.u.transformTimeFromSql(program.lu_end) : '18:00'
            ang.ma_start = program ? this.u.transformTimeFromSql(program.ma_start) : '00:00'
            ang.ma_end = program ? this.u.transformTimeFromSql(program.ma_end) : '18:00'
            ang.mi_start = program ? this.u.transformTimeFromSql(program.mi_start) : '00:00'
            ang.mi_end = program ? this.u.transformTimeFromSql(program.mi_end) : '18:00'
            ang.jo_start = program ? this.u.transformTimeFromSql(program.jo_start) : '00:00'
            ang.jo_end = program ? this.u.transformTimeFromSql(program.jo_end) : '18:00'
            ang.vi_start = program ? this.u.transformTimeFromSql(program.vi_start) : '00:00'
            ang.vi_end = program ? this.u.transformTimeFromSql(program.vi_end) : '18:00'
            ang.sa_start = program ? this.u.transformTimeFromSql(program.sa_start) : '00:00'
            ang.sa_end = program ? this.u.transformTimeFromSql(program.sa_end) : '18:00'
            ang.du_start = program ? this.u.transformTimeFromSql(program.du_start) : '00:00'
            ang.du_end = program ? this.u.transformTimeFromSql(program.du_end) : '18:00'



            let depNew = []


            ang.data_nastere = this.u.ParseDataFromSql(ang.data_nastere)


            let idxDep = dep.findIndex(d => Number(d.id) === Number(ang.id_departament))



            if (idxDep !== -1) {

                ang['nume_departament'] = dep[idxDep].nume
            }

            let punctajMaxim = 0

            punctajMaxim = optiuniR.reduce((a, r) => { return a + (r.puncte || 0) }, 0)

            punctajMaxim = punctajMaxim / evaluari.length







            for (let j = 0, m = evaluari.length; j < m; j++) {
                let pct = 0



                console.log('punctajMaxim :>> ', punctajMaxim);

                console.log('evaluari[j] :>> ', evaluari[j]);


                let filterR = optiuniR.filter(o => o.id_evaluare === evaluari[j].id)

                if (filterR.length > 0) {
                    for (let k = 0, l = filterR.length; k < l; k++) {


                        pct += filterR[k].raspuns ? filterR[k].puncte : 0 || 0
                    }

                    evaluari[j].puncte = pct
                }

                evaluari[j].procent_completare = Math.floor(((evaluari[j].completari_finalizate * 100) / evaluari[j].completari_toate) || 0)

                evaluari[j].color = evaluari[j].procent_completare >= 80 ? 'rgb(24 165 58)' : (evaluari[j].procent_completare < 80 && evaluari[j].procent_completare >= 50 ? 'rgb(227 154 10)' : 'rgb(252,93,98)')
                evaluari[j].color_puncte = evaluari[j].puncte >= (punctajMaxim - (punctajMaxim / 3)) ? 'rgb(24 165 58)' : (evaluari[j].puncte < (punctajMaxim - (punctajMaxim / 3)) && evaluari[j].puncte >= (punctajMaxim / 2) ? 'rgb(227 154 10)' : 'rgb(252,93,98)')
                evaluari[j].checked = false
                evaluari[j].raspunsuri = filterR



            }






            console.log('ang :>> ', ang);

            console.log('dep :>> ', dep);

            console.log('evaluari :>> ', evaluari);

            let filterEvaluari = evaluari.filter(ee => ee.tip === "evaluare_angajati")

            console.log('filterEvaluari :>> ', filterEvaluari);

            var maxId = Math.max(...filterEvaluari.map(e => e.id));


            let idxEvaluareAngajati = filterEvaluari.findIndex(uE => uE.id === maxId)

            let ultimaEvaluareAngajati = filterEvaluari[idxEvaluareAngajati]







            let filterEvaluariManager = evaluari.filter(ee => ee.tip === "evaluare_sefi")
            var maxId = Math.max(...filterEvaluariManager.map(e => e.id));
            let idxEvaluareManager = filterEvaluariManager.findIndex(uE => uE.id === maxId)
            let ultimaEvaluareManager = filterEvaluariManager[idxEvaluareManager]

            let filterEvaluariClienti = evaluari.filter(ee => ee.tip === "evaluare_clienti")
            var maxId = Math.max(...filterEvaluariClienti.map(e => e.id));
            let idxEvaluareClienti = filterEvaluariClienti.findIndex(uE => uE.id === maxId)
            let ultimaEvaluareClienti = filterEvaluariClienti[idxEvaluareClienti]


            console.log('evaluareClienti :>> ', ultimaEvaluareClienti);
            console.log('evaluareManager :>> ', ultimaEvaluareManager);
            console.log('ultimaEvaluareAngajati :>> ', ultimaEvaluareAngajati);


            this.setState({
                angajat: ang,
                departamente: dep,
                evaluari: evaluari,
                ultimaEvaluareAngajati: ultimaEvaluareAngajati || null,
                ultimaEvaluareManager: ultimaEvaluareManager || null,
                ultimaEvaluareClienti: ultimaEvaluareClienti || null,
                loading: false



            })


        }




    }


    saveProgram = async () => {

        let ws = new Ws();

        let verifyProgram = await ws.customSelect('select count(*) as c from program_lucru where id_angajat = @p1', {
            p1: this.state.angajat.id
        })

        let objToInsert = {
            lu_start: this.state.angajat.lu_start,
            lu_end: this.state.angajat.lu_end,
            ma_start: this.state.angajat.ma_start,
            ma_end: this.state.angajat.ma_end,
            mi_start: this.state.angajat.mi_start,
            mi_end: this.state.angajat.mi_end,
            jo_start: this.state.angajat.jo_start,
            jo_end: this.state.angajat.jo_end,
            vi_start: this.state.angajat.vi_start,
            vi_end: this.state.angajat.vi_end,
            sa_start: this.state.angajat.sa_start,
            sa_end: this.state.angajat.sa_end,
            du_start: this.state.angajat.du_start,
            du_end: this.state.angajat.du_end,
            id_angajat: this.state.angajat.id

        }

        let objToUpdate = {
            lu_start: this.state.angajat.lu_start,
            lu_end: this.state.angajat.lu_end,
            ma_start: this.state.angajat.ma_start,
            ma_end: this.state.angajat.ma_end,
            mi_start: this.state.angajat.mi_start,
            mi_end: this.state.angajat.mi_end,
            jo_start: this.state.angajat.jo_start,
            jo_end: this.state.angajat.jo_end,
            vi_start: this.state.angajat.vi_start,
            vi_end: this.state.angajat.vi_end,
            sa_start: this.state.angajat.sa_start,
            sa_end: this.state.angajat.sa_end,
            du_start: this.state.angajat.du_start,
            du_end: this.state.angajat.du_end,

        }

        // console.log('objToInsert :', objToInsert);


        // console.log('verifyProgram :', verifyProgram);
        if (verifyProgram.Succes) {
            if (verifyProgram.Content[0].c === 0) {
                let insertProgram = await ws.insert('program_lucru', objToInsert)

                if (insertProgram.Succes) {
                    this.setState({ isOpenProgram: false })
                }
            } else {
                let updateProgram = await ws.update('program_lucru', objToUpdate, { id_angajat: this.state.angajat.id })

                if (updateProgram.Succes) {
                    this.setState({ isOpenProgram: false })
                }
            }
        }
    }


    changeProgramAll = (ev) => {

        let val = ev.target.value

        let programe = [...this.state.programCompanie]

        let idx = programe.findIndex(i => Number(i.id) === Number(val))

        console.log('idx :>> ', idx);
        if (idx !== -1) {

            let angajatInfo = { ...this.state.angajat }

            angajatInfo.lu_start = programe[idx].lu_start
            angajatInfo.lu_end = programe[idx].lu_end
            angajatInfo.ma_start = programe[idx].ma_start
            angajatInfo.ma_end = programe[idx].ma_end
            angajatInfo.mi_start = programe[idx].mi_start
            angajatInfo.mi_end = programe[idx].mi_end
            angajatInfo.jo_start = programe[idx].jo_start
            angajatInfo.jo_end = programe[idx].jo_end
            angajatInfo.vi_start = programe[idx].vi_start
            angajatInfo.vi_end = programe[idx].vi_end
            angajatInfo.sa_start = programe[idx].sa_start
            angajatInfo.sa_end = programe[idx].sa_end
            angajatInfo.du_start = programe[idx].du_start
            angajatInfo.du_end = programe[idx].du_end



            this.setState({
                angajat: angajatInfo,
                programSelectat: val
            }, () => {
                this.saveProgram()
            })
        }

    }

    getProgramCompanie = async () => {

        let getProgram = await this.ws.customSelect('select * from program_lucru where isnull(este_template,0)=1 and isnull(sters,0)!=1', {
            p1: 1
        })

        if (getProgram.Succes) {

            let programCompanie = [...getProgram.Content]

            for (let i = 0, n = programCompanie.length; i < n; i++) {

                programCompanie[i].lu_start = this.u.transformTimeFromSql(programCompanie[i].lu_start)
                programCompanie[i].lu_end = this.u.transformTimeFromSql(programCompanie[i].lu_end)
                programCompanie[i].ma_start = this.u.transformTimeFromSql(programCompanie[i].ma_start)
                programCompanie[i].ma_end = this.u.transformTimeFromSql(programCompanie[i].ma_end)
                programCompanie[i].mi_start = this.u.transformTimeFromSql(programCompanie[i].mi_start)
                programCompanie[i].mi_end = this.u.transformTimeFromSql(programCompanie[i].mi_end)
                programCompanie[i].jo_start = this.u.transformTimeFromSql(programCompanie[i].jo_start)
                programCompanie[i].jo_end = this.u.transformTimeFromSql(programCompanie[i].jo_end)
                programCompanie[i].vi_start = this.u.transformTimeFromSql(programCompanie[i].vi_start)
                programCompanie[i].vi_end = this.u.transformTimeFromSql(programCompanie[i].vi_end)
                programCompanie[i].sa_start = this.u.transformTimeFromSql(programCompanie[i].sa_start)
                programCompanie[i].sa_end = this.u.transformTimeFromSql(programCompanie[i].sa_end)
                programCompanie[i].du_start = this.u.transformTimeFromSql(programCompanie[i].du_start)
                programCompanie[i].du_end = this.u.transformTimeFromSql(programCompanie[i].du_end)


                programCompanie[i].lu_pauza_start = this.u.transformTimeFromSql(programCompanie[i].lu_pauza_start)
                programCompanie[i].lu_pauza_end = this.u.transformTimeFromSql(programCompanie[i].lu_pauza_end)
                programCompanie[i].ma_pauza_start = this.u.transformTimeFromSql(programCompanie[i].ma_pauza_start)
                programCompanie[i].ma_pauza_end = this.u.transformTimeFromSql(programCompanie[i].ma_pauza_end)
                programCompanie[i].mi_pauza_start = this.u.transformTimeFromSql(programCompanie[i].mi_pauza_start)
                programCompanie[i].mi_pauza_end = this.u.transformTimeFromSql(programCompanie[i].mi_pauza_end)
                programCompanie[i].jo_pauza_start = this.u.transformTimeFromSql(programCompanie[i].jo_pauza_start)
                programCompanie[i].jo_pauza_end = this.u.transformTimeFromSql(programCompanie[i].jo_pauza_end)
                programCompanie[i].vi_pauza_start = this.u.transformTimeFromSql(programCompanie[i].vi_pauza_start)
                programCompanie[i].vi_pauza_end = this.u.transformTimeFromSql(programCompanie[i].vi_pauza_end)
                programCompanie[i].sa_pauza_start = this.u.transformTimeFromSql(programCompanie[i].sa_pauza_start)
                programCompanie[i].sa_pauza_end = this.u.transformTimeFromSql(programCompanie[i].sa_pauza_end)
                programCompanie[i].du_pauza_start = this.u.transformTimeFromSql(programCompanie[i].du_pauza_start)
                programCompanie[i].du_pauza_end = this.u.transformTimeFromSql(programCompanie[i].du_pauza_end)
            }


            console.log('programCompanie :>> ', programCompanie);
            this.setState({
                programCompanie: programCompanie,
                programSelectat: programCompanie.length > 0 ? programCompanie[0] : null

            })
        }
    }


    changeProgram = nume => ev => {
        let oldState = { ...this.state.angajat }

        oldState[nume] = ev.target.value

        console.log('ev.target.value :>> ', ev.target.value);
        console.log('nume :>> ', nume);

        this.setState({
            angajat: oldState
        })
    }

    absent = (ev, zi) => {
        //    console.log('ev :', ev);

        //    console.log('zi :', zi);

        let oldState = { ...this.state.angajat }

        if (oldState[zi] === '00:00') {
            oldState[zi] = '09:00'
        } else {
            oldState[zi] = '00:00'
        }
        this.setState({
            angajat: oldState
        })
    }


    changeAngajat = (ev) => {

        let val = ev.target.value
        let n = ev.target.name


        let objAng = { ...this.state.angajat }

        objAng[n] = val


        if (n === 'id_departament') {

            let idx = this.state.departamente.findIndex(dep => Number(dep.id) === Number(val))

            if (idx !== -1) {

                objAng['nume_departament'] = this.state.departamente[idx].nume
            }
        }

        this.setState({ angajat: objAng })
    }

    updateAngajatData = async () => {

        let angajat = {
            email: this.state.angajat.email || '',
            telefon: this.state.angajat.telefon || 0,
            oras: this.state.angajat.oras || '',
            adresa: this.state.angajat.adresa || '',
            permis_conducere: this.state.angajat.permis_conducere || '',
            nume: this.state.angajat.nume || '',
            // nume_familie:this.state.angajat.nume_familie || '',
            data_nastere: this.state.angajat.data_nastere === 'null' ? this.u.defaultData() : (this.state.angajat.data_nastere || this.u.defaultData()),
            serie_ci: this.state.angajat.serie_ci || '',
            functie: this.state.angajat.functie || '',
            salariu: this.state.angajat.salariu || 0,
            pozitie: this.state.angajat.pozitie || '',
            cnp: this.state.angajat.cnp || 0,
            salariu_brut: this.state.angajat.salariu_brut || 0,
            tichete_masa: this.state.angajat.tichete_masa || 0,



        }


        console.log('updateAngajatData :>> ', angajat);


        let getLegaturaDepartamente = await this.ws.customSelect(`select * from angajati_departamente where id_angajat = @p1`, {
            p1: this.state.angajat.id
        })

        if (getLegaturaDepartamente.Succes) {

            if (getLegaturaDepartamente.Content.length > 0) {
                let updateLegaturaDepartamente = await this.ws.update('angajati_departamente', { id_departament: this.state.angajat.id_departament || '' }, { id_angajat: this.state.angajat.id })

                if (updateLegaturaDepartamente.Succes) {
                    let updateAngajat = await this.ws.update('angajati', angajat, { id: this.state.angajat.id })

                    if (updateAngajat.Succes) {
                        // this.getData()
                    }
                }
            } else {

                let insertLegaturaDepartamente = await this.ws.insert('angajati_departamente', {
                    id_departament: this.state.angajat.id_departament || '',
                    id_angajat: this.state.angajat.id
                })

                if (insertLegaturaDepartamente.Succes) {
                    let updateAngajat = await this.ws.update('angajati', angajat, { id: this.state.angajat.id })

                    if (updateAngajat.Succes) {
                        // this.getData()  
                    }
                }

            }
        }





    }


    angajeaza = async () => {

        let angajat = { ...this.state.angajat }

        angajat.statusul = 'In Curs de Angajare'

        let updateStatus = await this.ws.update('angajati', { statusul: angajat.statusul }, { id: angajat.id })

        if (updateStatus.Succes) {
            this.setState({ loading: true }, () => {
                this.getData()
            })

        }

    }


    angajare = async () => {
        let angajat = { ...this.state.angajat }

        angajat.statusul = 'Activ'

        let objUser = {
            token: this.u.randomData(32),
            nume: this.state.angajat.nume || '',
            email: this.state.angajat.email || '',
            telefon: this.state.angajat.telefon || ''

        }

        let insertU = await this.ws.insert('useri', objUser)

        if (insertU.Succes) {

            let updateStatus = await this.ws.update('angajati', { statusul: 'Activ', id_user: insertU.Content[0].id, data_angajarii: this.u.updateSqlNow() }, { id: angajat.id })

            if (updateStatus.Succes) {


                let getSocietate = await this.ws.customSelect('select * from setari where param_code = @p1', {
                    p1: 'soc_id'
                })


                if (getSocietate.Succes) {



                    let objNewUserLogator = {
                        token: objUser.token,
                        nume: this.state.angajat.nume,
                        id_societate_client: getSocietate.Content[0].val,
                        email: this.state.angajat.email,
                        parola: '123456',
                        parolac: '123456',
                        id_user_bazadate_proprie: insertU.Content[0].id,
                    }


                    let iUserDrepturi = await this.ws.insert('useri_drepturi', {
                        id_utilizator: insertU.Content[0].id,

                        profil_selectat: this.state.angajat['sef_departament'] ? 'Manager' : 'Angajat',

                        acces_rapoarte: this.state.angajat['sef_departament'] ? 1 : 0,
                        acces_setari: this.state.angajat['sef_departament'] ? 1 : 0,
                        acces_utilizatori: this.state.angajat['sef_departament'] ? 1 : 0,

                        acces_extins_proiecte: this.state.angajat['sef_departament'] ? 1 : 0,

                        acces_evaluari: this.state.angajat['sef_departament'] ? 1 : 0,
                        can_edit_evaluari: this.state.angajat['sef_departament'] ? 1 : 0,

                        acces_monitorizare: this.state.angajat['sef_departament'] ? 1 : 0,
                        can_edit_monitorizare: this.state.angajat['sef_departament'] ? 1 : 0,

                        sterge_proiecte: 0

                    })


                    if (iUserDrepturi.Succes) {
                        let insertNewUser = await this.ws.insert('pm_logator.[dbo].useri', objNewUserLogator)

                        console.warn('insertNewUser :>> ', insertNewUser);

                        if (insertNewUser.Succes) {
                            this.setState({ loading: true }, () => {

                                this.getData()
                            })
                        }
                    }
                }
            }

        }

    }


    render() {
        return (
            <div>

                <AlertNew
                    open={this.state.alertView}
                    dialogClose={() => { this.setState({ alertView: false }) }}
                    title={this.dictionary.proiecte.alertView}
                    mesaj={this.dictionary.proiecte.alertViewMessage}
                    noButtonDisplay={1}
                    yesFunction={() => { this.props.history.replace('/') }}
                    fullScreen={true}
                />
                <CustomAppBar history={this.props.history} title={' '} />

                {this.state.loading &&
                    <div className='loading-div' >

                        <CircularProgress
                            style={{
                                width: 60,
                                height: 60,
                                color: '#25e048',
                                marginTop: '40%'
                            }}
                            value={20}

                        />
                        <span style={{ display: 'block', fontSize: 20 }}>Loading...</span>
                    </div>
                }
                <Grid style={{ maxWidth: 1300, margin: 'auto', marginBottom: 40 }} container >
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <h1 style={{ margin: '80px 0 40px 0' }} className='pm-title-big'>{this.dictionary.pontaje.rapoarte} </h1>
                    </Grid>


                    {this.state.angajat &&
                        <RaportPersonalSubItem
                            angajat={this.state.angajat}
                            changeAngajatData={this.changeAngajat}
                            updateAngajatData={this.updateAngajatData}
                            ultimaEvaluareAngajati={this.state.ultimaEvaluareAngajati}
                            ultimaEvaluareManager={this.state.ultimaEvaluareManager}
                            ultimaEvaluareClienti={this.state.ultimaEvaluareClienti}
                            history={this.props.history}
                        />
                    }



                </Grid>





            </div>
        );
    }
}